module.exports = __webpack_public_path__ + "img/promo-ciaz.8a1887a3.jpg";